import { useNavigate } from '@tanstack/react-router'
import { useAccountEffect } from 'wagmi'

import { useConnectModal } from '@/domain/hooks/wallet'
import { Button } from '@/ui/atoms/button/Button'
import { ErrorLayout } from '@/ui/layouts/ErrorLayout'

export function NotConnected({ fullScreen }: { fullScreen?: boolean }) {
  const { openConnectModal } = useConnectModal()
  const navigate = useNavigate()
  useAccountEffect({
    onConnect: () => {
      void navigate({ to: '/' })
    },
  })

  return (
    <ErrorLayout fullScreen={fullScreen}>
      <div className="typography-heading-3">This page is available only for connected users</div>
      <Button onClick={openConnectModal}>Connect wallet</Button>
    </ErrorLayout>
  )
}
